import React from "react";
import { Link } from "react-router-dom";
import {
  ShieldCheckIcon,
  LockKeyIcon,
  LightningIcon,
  ArrowUUpLeftIcon,
} from "@phosphor-icons/react";

const REASONS = [
  {
    icon: ShieldCheckIcon,
    title: "Every seller is ID-verified",
    body: "US government photo ID matched to a real face. No alt accounts. No fake handles.",
  },
  {
    icon: LockKeyIcon,
    title: "Escrow-protected payments",
    body: "Stripe holds your money until the item ships and you confirm delivery. If it doesn't show up, you don't pay.",
  },
  {
    icon: LightningIcon,
    title: "Real-time bids that can't be spoofed",
    body: "Our anti-shill detector flags suspicious bid patterns live. Zero tolerance for fake bidding.",
  },
  {
    icon: ArrowUUpLeftIcon,
    title: "7-day return window on fixed-price",
    body: "Item doesn't match the listing? Return it for a full refund within 7 days. Simple.",
  },
];

export default function WhyBuyersLove() {
  return (
    <section
      className="bg-white border-b border-zinc-200"
      data-testid="home-why-buyers"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <p className="text-sm font-semibold text-[#1D78AB] mb-3">
              For buyers
            </p>
            <h2 className="font-display font-black text-4xl lg:text-5xl tracking-tighter max-w-xl">
              Why collectors trust Bidorah over everyone else.
            </h2>
          </div>
          <Link
            to="/why-bidorah"
            className="text-sm font-semibold text-[#1D78AB] hover:underline"
            data-testid="home-why-buyers-link"
          >
            See the full comparison →
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {REASONS.map((r) => (
            <div
              key={r.title}
              className="rounded-3xl p-6 bg-zinc-50 border border-zinc-100 hover:bg-white hover:border-[#1D78AB]/30 transition"
              data-testid={`buyer-reason-${r.title.slice(0, 12).toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="h-11 w-11 rounded-2xl bg-[#1D78AB]/10 text-[#1D78AB] grid place-items-center">
                <r.icon size={20} weight="fill" />
              </div>
              <h3 className="font-display font-black text-lg tracking-tight mt-4 leading-tight">
                {r.title}
              </h3>
              <p className="text-sm text-zinc-600 mt-2 leading-relaxed">
                {r.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
